import { useAuth } from '../context/AuthContext';
import AdminLogin from '../components/AdminLogin';
import AdminDashboard from '../components/AdminDashboard';

export default function AdminPage() {
  const { isAuthenticated } = useAuth();
  return (
    <div className="admin-shell">
      {isAuthenticated ? <AdminDashboard /> : <AdminLogin />}
    </div>
  );
}
